import React from 'react';

const loadingGif = require('images/etc/infinity.gif');

export default function () {
  return <img src={loadingGif} className="loading-indicator" role="presentation" style={{ margin: '0 auto', display: 'block' }} />;
}
